<template lang="pug">
ods-form.login-form(
  :model='loginForm',
  :rules='rules',
  ref='loginForm'
  :hide-required-asterisk="true")
  div
    div(align='center')
        img(:src='getImgUrl()')
    h1.login-form__title {{ $t('login.welcome') }}
    .login-form__errors(v-show="errors")
      ods-alert(
        :title="errorInfo || $t('login.error.invalid_user')",
        type='error',
        :closable='false')
    ods-form-item(:label="$t('login.userLabel')" prop='username' class="ods-mb-10")
      ods-input(
        :class='{error: errors}',
        type='text',
        v-model.trim='loginForm.username')
    ods-form-item(:label="$t('login.passLabel')" prop='password')
      ods-input(
        :class='{error: errors}',
        type='password',
        show-password,
        v-model.trim='loginForm.password')
  div.vocento(align='center',
    v-if="this.localproject =='vocento'")
    h1.login-form__titlevocento {{ $t('login.titlevocento') }}
    h2.login-form__textovocento {{ $t('login.textvocento') }}
    h1.login-form__titlevocento2 {{ $t('login.titlevocento2') }}
    h1.login-form__emailvocento
      a(href="mailto:gestion.facturacion@vocento.com") {{ 'gestion.facturacion@vocento.com' }}
      h2.login-form__textovocentohorario2 {{ $t('login.horariovocento') }}
      h2.login-form__textovocentohorario {{ $t('login.horario2vocento') }}
    h1.login-form__linkvocento
      ods-icon(name='sort-right')
      a(href="https://www.vocento.com/aviso-legal" target='_blank') {{ $t('login.avisolegal') }}
    h1.login-form__linkvocento
      ods-icon(name='sort-right')
      a(href="https://www.vocento.com/politica-privacidad-vocento-corporativa" target='_blank') {{ $t('login.politica') }}
  div
  div.login-form__actions
    router-link(:to='next' ,tag='div')
      ods-button.ods-p-0(type='neutral') {{ $t('login.passRecovery') }}
    ods-button.ods-button__custom(type='primary', native-type='submit', @click.prevent="submitForm('loginForm')") {{ $t('buttons.btnEnter') }}
  div(align='center',
    v-if="this.localproject =='renfe'")
    h1.login-form__cau.margincau {{ $t('login.cautext') }}
    h1.login-form__cau {{ $t('login.cautelephone') }}
  div(align='left',
    v-if="this.localproject =='redelectrica'")
    .ods-form-item__content.contrat
      p {{ $t('login.contratLabel') }}
      p
        a(href="https://www.redeia.com/es/efactura")
          | {{$t('login.contratLabelRef')}}
      p
        a(href="https://www.redeia.com/es/efactura/informacion-e-factura")
          | {{$t('login.helpLabelRef')}}
    .ods-form-item__content.info
      p
        span.bold {{ $t('login.labelRef1') }}
        span {{ $t('login.labelRef2') }}
      p {{ $t('login.labelRef3') }}
        a(href="https://www.redeia.com/es/politica-de-privacidad")
          | {{ $t('login.labelRef4') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'

export default {
  name: 'login-form-generic',
  props: {
    css: {
      type: String
    },
    logo: {
      type: String
    },
    next: {
      type: String
    },
    localproject: {
      type: String
    },
    logomenu: {
      typlogomenue: String
    }
  },

  data () {
    return {
      invoiceNoteId: null,
      loginForm: {
        user: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: this.$t('login.rules.username'), trigger: 'submit' }
        ],
        password: [
          { required: true, message: this.$t('login.rules.password'), trigger: 'submit' }
        ]
      },
      errors: false,
      errorInfo: ''
    }
  },

  computed: {
    ...mapGetters(['canSearchInvoiceSales'])
  },

  methods: {
    ...mapActions([
      'login',
      'parseUserAuthorities',
      'localprojectAction',
      'loadLogoMenuAction',
      'chargeUrlIn'
    ]),

    getImgUrl () {
      if (this.logo !== null) {
        return require('../../assets/images/login/' + this.logo)
      } else {
        return ''
      }
    },

    submitForm (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('login.logging')
          })
          try {
            const data = {
              password: this.loginForm.password.trim(),
              username: this.loginForm.username.trim(),
              responseCaptcha: null,
              css: this.css,
              urlIn: this.localproject
            }
            await this.login(data)
            this.parseUserAuthorities()
            console.log('id de factura: ', this.invoiceNoteId)

            router.push({
              name: 'b2b-app',
              params: {
                password: this.loginForm.password.trim(),
                username: this.loginForm.username.trim(),
                invoiceId: this.invoiceNoteId
              }
            })
          } catch (error) {
            console.log('LOGIN CATCH: ', error)
            let errorSms = ''
            let statusCode = null
            if (error !== undefined) {
              statusCode = error.status
            }
            switch (statusCode) {
              case 400:
                errorSms = this.$t('error.e400')
                break
              case 401:
                errorSms = this.$t('error.e401_login')
                break
              case 428:
                errorSms = this.$t('error.e428_login')
                router.push({
                  name: 'twoFactorAuth-form'
                })
                return
              case 500:
                errorSms = this.$t('error.e500')
                break
              default:
                errorSms = 'Error de conexión con el servidor'
                break
            }
            this.$notify({
              title: errorSms,
              type: 'error',
              position: 'top-right',
              customClass: 'b2b-notification-error',
              duration: 10000
            })
            this.errors = true
            this.errorInfo = errorSms
          } finally {
            load.close()
          }
        } else {
          console.log('error submit!!')
          this.errors = true
          return false
        }
      })
    }
  },

  async created () {
    // si se indica el id de una factura pendiente
    this.invoiceNoteId = this.$route.query.id
    console.log('id de factura1: ', this.invoiceNoteId)

    // Ponemos los estilos
    await this.loadLogoMenuAction(this.logomenu)
    await this.localprojectAction(this.localproject)
    await this.chargeUrlIn(this.localproject)
    if (this.$apiBaseUrl && this.$apiBaseUrl.includes('ree')) {
      await this.chargeUrlIn('redelectrica')
    } else if (this.$apiBaseUrl && this.$apiBaseUrl.includes('red.es')) {
      await this.chargeUrlIn('red.es')
    }
  }
}

</script>

<style lang="scss" scoped>
.login-form {
  width: 100%;
  padding-top: $space-200;

  @include mediaXs {
    max-width: rem(300);
    padding-top: $space-700;
    min-width: rem(230);
  }

  /* login title & description */

  &__title {
    text-align: center;
    font-size: 20px;
    font-weight: 300;
    margin: 34px 0;
  }
  &__cau {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: #8a0072;
  }
  &__canalcau {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: #0084c9;
  }
  h1.login-form__cau.margincau {
    margin-top: 5%;
  }
  .vocento {
    float: left;
    position: absolute;
    margin-left: 280px;
    background-color: #0000008f;
    width: 23%;
    height: 84.3%;
    margin-top: -20px;
  }
  .login-form__titlevocento {
    text-align: justify;
    font-size: 16px;
    font-weight: bold;
    font-family: sans-serif;
    margin: 34px 10px 0px 10px;
    color: white;
  }
  .login-form__textovocento {
    text-align: justify;
    font-size: 16px;
    font-family: sans-serif;
    margin: 25px 30px 25px 30px;
    color: lightgray;
  }

  .login-form__titlevocento2 {
    text-align: justify;
    font-size: 16px;
    font-family: sans-serif;
    margin: 25px 10px 10px 30px;
    color: white;
  }
  .login-form__emailvocento {
    text-align: justify;
    font-size: 16px;
    font-family: sans-serif;
    margin: 0px 10px 25px 30px;
    color: lightgray;
    a {
      color: rgb(175, 189, 248);
    }
  }

  .login-form__textovocentohorario {
    text-align: justify;
    font-size: 16px;
    font-family: sans-serif;
    margin: 0px 25px 2px 0px;
    color: lightgray;
  }

  .login-form__textovocentohorario2 {
    text-align: justify;
    font-size: 16px;
    font-family: sans-serif;
    margin: 5px 10px 2px 0px;
    color: lightgray;
  }

  .login-form__linkvocento {
    text-align: justify;
    font-size: 13px;
    font-family: sans-serif;
    margin: 0px 10px 5px 30px;
    a {
      color: white;
      text-decoration: underline;
    }
  }
  span.ods-icon-sort-right {
    color: white;
    font-size: 16px;
  }

  &__description {
    @include txt-body-300;
    padding-bottom: $space-500;
    color: var(--color-txt-secondary);
  }

  /* label password */

  &__label-pass {
    display: flex;
    justify-content: space-between;
    padding-bottom: $space-050;

    @include txt-body-200;
    color: var(--color-txt-secondary);
  }

  /* Actions */

  &__actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: $space-200;
    .btnRcovery {
      padding-left: inherit;
      margin-inline-end: auto;
      background-color: transparent;
    }
  }

  /* Errors */

  &__errors {
    margin-bottom: $space-300;
  }

  /* Register */

  &__register {
    display: flex;
    justify-content: space-between;
    margin-top: $space-400;
    padding-top: $space-400;

    border-top: $border-size-200 dotted var(--color-border-hard-divisor);
    @include txt-body-400;
    text-align: center;

    & > a {
      color: var(--color-txt-interactive);
      margin-left: $space-200;
      transition: 0.3s all ease;

      &:hover {
        color: var(--color-bg-hover);
      }
    }
  }
}
</style>
